import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../modules/auth';
import { UserRole } from '../../../utils/userMapper';

export default function Unauthorized() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    // Redireciona para a página inicial baseada no role
    switch (user?.role) {
      case UserRole.ADMIN:
        navigate('/dashboard');
        break;
      case UserRole.ORGANIZER:
        navigate('/events');
        break;
      case UserRole.CUSTOMER:
        navigate('/visitors');
        break;
      default:
        navigate('/login');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', color: 'error.main' }}>
          401
        </Typography>
        <Typography variant="h4" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
          Você não tem permissão para acessar esta página. Entre em contato com o administrador se acredita que isso é um erro.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleGoHome}
          sx={{ mt: 2 }}
        >
          Voltar ao Início
        </Button>
      </Stack>
    </Box>
  );
}